// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltip {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.tooltip .tooltip-container {
  position: absolute;
  min-width: 300px;
  min-height: 80px;
  box-shadow: 0px 0px 16px 1px rgba(128, 128, 128, 0.473);
  background-color: white;
  z-index: 100;
  border-radius: 3px;
}
.tooltip .tooltip-container .tooltip-title {
  padding: 10px;
  background-color: rgb(247, 247, 247);
  border-radius: 3px 3px 0px 0px;
  font-weight: bold;
  font-size: 16px;
}
.tooltip .tooltip-container .tooltip-content {
  padding: 10px;
  font-size: 14px;
  border-radius: 0px 0px 3px 3px;
}
.tooltip .tooltip-right {
  top: 30px;
}
.tooltip .tooltip-right:before {
  content: "";
  position: absolute;
  top: -10px;
  left: calc(50% - 10px);
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-bottom: 10px solid white;
}
.tooltip .tooltip-left {
  right: 25px;
}
.tooltip .tooltip-left:before {
  content: "";
  position: absolute;
  right: -10px;
  top: calc(50% - 10px);
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid white;
}
.tooltip .tooltip-top {
  right: 30px;
  max-width: 250px;
  min-width: 250px;
}
.tooltip .tooltip-top:before {
  content: "";
  position: absolute;
  right: -10px;
  top: calc(50% - 10px);
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  border-left: 10px solid white;
}`, "",{"version":3,"sources":["webpack://./src/component/Tooltip/style.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACJ;AACI;EACI,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uDAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AACR;AACQ;EACI,aAAA;EACA,oCAAA;EACA,8BAAA;EACA,iBAAA;EACA,eAAA;AACZ;AAEQ;EACI,aAAA;EACA,eAAA;EACA,8BAAA;AAAZ;AAII;EACI,SAAA;AAFR;AAKI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,sBAAA;EACA,mCAAA;EACA,oCAAA;EACA,+BAAA;AAHR;AAMI;EACI,WAAA;AAJR;AAOI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;AALR;AAQI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AANR;AASI;EACI,WAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kCAAA;EACA,qCAAA;EACA,6BAAA;AAPR","sourcesContent":[".tooltip {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n\n    .tooltip-container {\n        position: absolute;\n        min-width: 300px;\n        min-height: 80px;\n        box-shadow: 0px 0px 16px 1px rgba(128, 128, 128, 0.473);\n        background-color: white;\n        z-index: 100;\n        border-radius: 3px;\n\n        .tooltip-title {\n            padding: 10px;\n            background-color: rgb(247 247 247);\n            border-radius: 3px 3px 0px 0px;\n            font-weight: bold;\n            font-size: 16px;\n        }\n\n        .tooltip-content {\n            padding: 10px;\n            font-size: 14px;\n            border-radius: 0px 0px 3px 3px;\n        }\n    }\n\n    .tooltip-right {\n        top: 30px;\n    }\n\n    .tooltip-right:before {\n        content: \"\";\n        position: absolute;\n        top: -10px;\n        left: calc(50% - 10px);\n        border-left: 10px solid transparent;\n        border-right: 10px solid transparent;\n        border-bottom: 10px solid white;\n    }\n\n    .tooltip-left {\n        right: 25px;\n    }\n\n    .tooltip-left:before {\n        content: \"\";\n        position: absolute;\n        right: -10px;\n        top: calc(50% - 10px);\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent;\n        border-left: 10px solid white;\n    }\n\n    .tooltip-top {\n        right: 30px;\n        max-width: 250px;\n        min-width: 250px;\n    }\n\n    .tooltip-top:before {\n        content: \"\";\n        position: absolute;\n        right: -10px;\n        top: calc(50% - 10px);\n        border-top: 10px solid transparent;\n        border-bottom: 10px solid transparent;\n        border-left: 10px solid white;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
